import React from "react";
import Input from './Form/Input'
import Next from './Next'


export default class UserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {...props.values}
    };
  }


  onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    var form = document.getElementById('userForm');
    var required = form.querySelectorAll('[required]');
    let valid = 0;
    Object.keys(required).map(f => {
      let field = required[f].getAttribute('name');
      if((this.state.data[field])&&(this.state.data[field] != ''))
        valid++;
    })
    if(valid == required.length)
      this.props.callback({field: 'userReady', value : true});
    form.classList.add('was-validated');
  }


  cb = (params) => {
    const n = { [params.field]: params.value };
    this.setState({data : {...this.state.data, ...n}});
    this.props.callback(params);
  }


  render() {
    return (
      <>
        <form id="userForm" onSubmit={this.onSubmit} noValidate className="row needs-validation">
          <div className="col-md-6 mb-4"><Input ix={1} name="name" label="Name" type="text" value={this.state.data.name} callback={this.cb} required={true} /></div>
          <div className="col-md-6 mb-4"><Input ix={2} name="lastName" label="Last Name" type="text" value={this.state.data.lastName} callback={this.cb} required={true} /></div>
          <div className="col-md-6 mb-4"><Input ix={3} name="email" label="Contact Email" type="email" value={this.state.data.email} callback={this.cb} required={true} /></div>
          <div className="col-md-6 mb-4"><Input ix={4} name="phone" label="Phone No." type="text" value={this.state.data.phone} callback={this.cb} /></div>
          <div className="col-md-8 mb-4"><Input name="company" label="Company" type="text" value={this.state.data.company} callback={this.cb} /></div>
          <div className="col-md-4 mb-5"><Input name="employees" label="Number of Employees" options={['1-5','5-15','15-50','50-100','100+']} type="select" value={this.state.data.employees} callback={this.cb} /></div>

          <Next callback={this.onSubmit} />
        </form>
      </>
    );
  }
}
